/**
 * @fileOverview Configure Backbone so that the Backbone Debugger Chrome
 * Developer Tools extension works.
 */
import Backbone from 'backbone';

if (window.__backboneAgent) {
    window.__backboneAgent.handleBackbone(Backbone);
}
